// import avatar from "../assets/img/avatar.png";
import logo from "../assets/img/menu.png";
const menuData = {
  sysName: "玖龙智通管理平台",
  logoSrc: logo,
  cpString: ``,
  acColor: "#409eff",
  bgColor: "#fff",
  menuData: [
    {
      name: "首页",
      path: "/rhqy/home",
      type: "text",
      privilege: ""
    },
    {
      name: "业务管理",
      path: "/rhqy/service",
      type: "text",
      privilege:
        // "c-base-data-logs-view&c-base-data-repo-mgr&c-base-data-repo-view&c-base-data-safe-mgr&c-car-apply-business-mgr&c-car-apply-business-view&c-car-apply-businessgrp-mgr&c-car-apply-businessgrp-view&c-car-apply-fast-mgr&c-car-apply-fast-view&c-car-apply-instance-mgr&c-car-apply-instance-view&c-car-apply-logs-view&c-car-apply-mine-mgr&c-car-apply-mine-view&c-car-apply-model-mgr&c-car-apply-model-view&c-car-apply-record-mgr&c-car-apply-record-view&c-car-pass-entry-mgr&c-car-pass-entry-view&c-car-pass-pass-logs&c-car-pass-pass-mgr&c-car-pass-pass-view&c-car-qeue-ww-leave-call&c-car-qeue-ww-leave-truck&c-car-qeue-ww-leave-view&c-car-queue-leave-mgr&c-car-queue-leave-view&c-car-queue-logs-view&c-coop-class-mgr&c-coop-class-view&c-coop-logs-view&c-coop-unit-mgr&c-coop-unit-view&c-proc-pass-class-mgr&c-proc-pass-class-view&c-proc-pass-msg-mgr&c-proc-pass-msg-view&c-ww-proc-pass-msg-view"
        "c-base-mp-coordinate-query&c-base-mp-door-query&c-base-mp-business-query&c-base-mp-carBusiness-query&c-base-mp-goods-query&c-base-mp-warehouse-query&c-base-mp-sampling-query&c-base-mp-guide-query&c-base-mp-safe-switch&c-base-mp-mtime-query&c-base-mp-itime-query&c-card-send-query&c-card-return-query&c-auth-record-query&c-calling-record-query&c-pound-record-query&c-clock-report-query&c-clock-collect-query&c-clock-record-query&c-booking-delivery-query&c-booking-pickup-query&c-inner-rs-receive-query&c-complaint-list-query&c-price-record-query&c-notice-record-query"
    },
    // {
    //   name: "应用设置",
    //   path: "/rhqy/yyManege",
    //   type: "text",
    //   privilege: "c-app-full-mgr"
    // },
    {
      name: "组织架构",
      path: "/rhqy/org",
      type: "text",
      privilege: "c-contact-contact-query"
    },
    {
      name: "权限管理",
      path: "/rhqy/pri",
      type: "text",
      privilege:
        "c-role-full-mgr"
    }
  ]
};

export { menuData };
